import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { LinkIcon, QrCodeIcon, FingerPrintIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import useModal from "../../../../hooks/useModal";
import toast from "react-hot-toast";

export default function NFTTableOptionsMenu({ nft }) {
    const {open} = useModal("nft-qr-modal");
    const nftDataModal = useModal("nft-data");
  
    return (<Menu as="div" className="relative inline-block text-left">
        <MenuButton className="inline-flex items-center gap-2 bg-gray-100 py-1.5 px-3 text-sm font-semibold rounded-lg shadow-sm cursor-pointer" id="nft-options-button">
            Options
            <ChevronDownIcon className="w-4 h-4" />
        </MenuButton>
        <MenuItems className="absolute right-0 mt-2 w-40 rounded-md bg-gray-100 shadow-lg focus:outline-none z-50 overflow-hidden"
            anchor="bottom end">
            <MenuItem>
                {({ active }) => (
                    <button
                            onClick={() => {
                                navigator.clipboard.writeText(nft?.link || nft?.url);
                                toast.success("Link copied to clipboard");
                            }}
                        className={`${active ? "bg-white" : ""
                            } group flex w-full items-center gap-2 px-4 py-2 text-sm text-gray-700 rounded-md`}
                    >
                        <LinkIcon className="w-4 h-4 text-gray-500" />
                        Copy link
                    </button>
                )}
            </MenuItem>

            <MenuItem>
                {({ active }) => (
                    <button
                        onClick={() => {
                            open(nft);
                        }}
                        className={`${active ? "bg-white" : ""
                            } group flex w-full items-center gap-2 px-4 py-2 text-sm text-gray-700 rounded-md`}
                    >
                        <QrCodeIcon className="w-4 h-4 text-gray-500" />
                        Show QR
                    </button>
                )}
            </MenuItem>

            <MenuItem>
                {({ active }) => (
                    <button
                        onClick={() => {
                            nftDataModal.open(nft);
                        }}
                        className={`${active ? "bg-white" : ""
                            } group flex w-full items-center gap-2 px-4 py-2 text-sm text-gray-700 rounded-md`}
                    >
                        <FingerPrintIcon className="w-4 h-4 text-gray-500" />
                        Edit Attributes
                    </button>
                )}
            </MenuItem>
        </MenuItems>
    </Menu>)
}